import ClassicEditor from './ClassicEditor'
import InlineEditor from './InlineEditor'

export { ClassicEditor, InlineEditor }

export default {
    ClassicEditor,
    InlineEditor,
}
